import React from 'react';
import { FileDto, FileType } from 'nekst-api';
import {
  BaseInputProps,
  useFormContextRequired,
  useInputHelper,
} from 'ui-builder';
import Layout from './Layout';

export interface FileUploaderInputProps extends BaseInputProps<number> {
  fileType: FileType,
  fileDataSource: string,
}

export function FileUploaderInput(
  props: FileUploaderInputProps
) {
  const inputHelper = useInputHelper<number>(props);

  const formContext = useFormContextRequired();

  const file = formContext.data![props.fileDataSource] as FileDto | undefined;

  return (
    <Layout
      {...inputHelper.getBaseInputLayoutProps()}
      fileType={props.fileType}
      fileDataSource={props.fileDataSource}
      file={file}
    />
  );
}
